import React from 'react';
import { Route } from 'react-router-dom';
import { routes } from '../../config';
import { NestedRoutes } from '../nested-routes';
import Callback from './callback';
import FakeCallback from './fake-callback';
import { Login } from './login';

export function AuthRoutes() {
  return (
    <NestedRoutes>
      <Route exact={true} path={routes.authentication.login}>
        <Login />
      </Route>

      <Route exact={true} path={routes.authentication.fakecallback}>
        <FakeCallback location={window.location.search} />
      </Route>

      <Route exact={true} path={routes.authentication.callback}>
        <Callback location={window.location.href} />
      </Route>
    </NestedRoutes>
  );
}
